export default "__VITE_ASSET__Hi5fDdJq__"